"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreButtonMenu = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const StyledPopover = (0, styled_components_1.default)(core_1.Popover) `
  margin-top: 12px;
`;
const MoreButtonMenu = (_a) => {
    var { iconButtonProps = {}, popoverProps = {}, children } = _a, props = __rest(_a, ["iconButtonProps", "popoverProps", "children"]);
    const [menuAnchor, setMenuAnchor] = (0, react_1.useState)();
    return (react_1.default.createElement("div", Object.assign({}, props),
        react_1.default.createElement(core_1.IconButton, Object.assign({ size: 'small', color: 'secondary', onClick: event => setMenuAnchor(event.currentTarget) }, iconButtonProps),
            react_1.default.createElement(icons_1.MoreVert, null)),
        menuAnchor && (react_1.default.createElement(StyledPopover, Object.assign({ open: true, anchorEl: menuAnchor, onClose: () => setMenuAnchor(undefined), anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' } }, popoverProps),
            react_1.default.createElement(core_1.List, { onClick: () => setMenuAnchor(undefined) }, children)))));
};
exports.MoreButtonMenu = MoreButtonMenu;
exports.default = exports.MoreButtonMenu;
//# sourceMappingURL=MoreButtonMenu.js.map